import { render, staticRenderFns } from "./ReferAFriendPopover.vue?vue&type=template&id=4adc763c"
import script from "./ReferAFriendPopover.vue?vue&type=script&lang=js"
export * from "./ReferAFriendPopover.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports